var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTap === 1),expression:"showTap === 1"}]},[_c('HomePage')],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTap === 2),expression:"showTap === 2"}]},[_c('TrafficIndex',{attrs:{"val":_vm.result}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }